import { setupDeleteConfirmation } from '../lib/delete-confirmation';

document.addEventListener('DOMContentLoaded', () => {
    setupDeleteConfirmation('.form-delete-payment', {
        title: 'Delete Payment',
        text: 'Are you sure you want to delete this payment? This action cannot be undone.',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'Cancel'
    });
});
